module.exports = __webpack_public_path__ + "img/Group 97.2136a0b9.svg";